import React, { useCallback, useState } from 'react';
import RestaurantListing from './Components/RestaurantsList';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { slugify, useUserActivity } from './Explore/services';
import { getTopRestaurants } from '../../lib/api/feed.apis';

const ListTop: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { trackClick } = useUserActivity();
  const cityName = searchParams.get('name');
  
  const navigate = useNavigate();

    const handleCardClick = useCallback((id: string, name: string) => {
      trackClick(id.toString());
      navigate(`/restaurant/${id || "1"}/${slugify(name) || "unknown"}/`);
    }, [trackClick, navigate]);

    const handleBack = () => {
      if (window.history.length > 1) {
      navigate(-1);
      } else {
      navigate("/");
      }
    };
    
    // Safety: handle missing area name
    if (!cityName) {
        return (
        <div>
            <p>City not specified.</p>
            <button onClick={() => navigate("/")}>Home</button>
        </div>
        );
    }

  return (
    <RestaurantListing
      title={`Restaurants in ${cityName}`}
      fetchRestaurants={(page, filters) => getTopRestaurants(cityName, filters, page)}
      onBack={handleBack}
      onRestaurantClick={handleCardClick}
    />
  );
};

export default ListTop;
